<div *ngIf="show" class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		
		<!-- In case of multiple choice -- same callback set for "NO" answer -->
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn" *ngIf="msg && msg.doppiaScelta">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button"
				(click)="closeConfirmModal();">Chiudi</button>
		</p>

		<!-- In case of button OK -- same callback set for "OK" answer -->
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn" style="display: flex; align-items: center;justify-content: end; padding: 0;" *ngIf="msg && !msg.doppiaScelta">
			<button style="width: 100px;" class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button"
				(click)="closeConfirmModal();">Chiudi</button>
		</p>

		<div class="col-sm-12 coldx">
			<h4>{{ title }}</h4>
		</div>

		<div class="row">
			<p class="col-sm-12">{{ msg?.messageDescription}}</p>
		</div>
		<div class="row" *ngIf="msg && msg.doppiaScelta">
			<p class="col-sm-3 col-xs-3 col-xs-offset-6 col-sm-offset-6">
				<button (click)="closeAndExit()" class="btn btn-primary btn-block">Si</button>
			</p>
			<p class="col-sm-3 col-xs-3">
				<button (click)="onCancelClick()" class="btn btn-primary btn-block">No</button>
			</p>
		</div>
		<div class="row" *ngIf="msg && !msg.doppiaScelta">
			<p class="col-sm-2 col-xs-2 col-xs-offset-5 margin-top-15">
				<button (click)="closeAndRedirect(msg)"
					class="btn btn-primary btn-block">Ok</button>
			</p>
		</div>
	</div>
</div>
